import { Form } from '@autoprog/core-client';

import CE_Select2 from '@libs/customElement/Select2';

import S_C_Order from '@services/Customer/CustomerOrderService';
import S_Customer from '@services/Customer/CustomerService';
import S_P_Order from '@services/Provider/ProviderOrderService';
import S_Provider from '@services/Provider/ProviderService';
import S_Receipt from '@services/ReceiptService';

class InputTracaForm extends HTMLElement {
	public static readonly tagName: string = 'ap-input-traca-form';

	private selectPostinit: { [key: string]: CE_Select2 } = {};

	private form: Form | null = null;

	public async connectedCallback() {
		this.classList.add('w-100');

		const mode = this.getAttribute('mode');

		this.innerHTML = `
			<div class="d-flex ${mode === 'vertical' ? 'flex-column' : ''}" id="form">

				<div class="d-flex flex-column pr-2 ${mode === 'vertical' ? 'mb-3' : ''}">
					
					<div class="font-weight-bold mb-2">
						Veuillez sélectionner un type d'entrée
					</div>

					<div class="custom-control custom-radio custom-control-inline mb-2">
						<input type="radio" id="provider" name="type" class="custom-control-input" value="provider" checked>
						<label class="custom-control-label" for="provider">Arrivée fournisseur</label>
					</div>

					<div class="custom-control custom-radio custom-control-inline mb-2">
						<input type="radio" id="customer" name="type" class="custom-control-input" value="customer">
						<label class="custom-control-label" for="customer">Retour Client</label>
					</div>

					<div class="custom-control custom-radio custom-control-inline">
						<input type="radio" id="stock" name="type" class="custom-control-input" value="stock">
						<label class="custom-control-label" for="stock">Transfert Stock</label>
					</div>
				</div>

				<div class="card border-radius flex-grow-1" id="container-provider">
					<div class="card-body">

						<div>
							<label>Commande fournisseur :</label>
							<ap-select2-button name="traceability.command_provider" table="commands-provider"
								hidden-btn-add="true" hidden-btn-edit="true">
							</ap-select2-button>
						</div>

						<div class="mt-2">
							<label>Fournisseur :</label>
							<ap-select2-button name="traceability.provider" table="providers">
							</ap-select2-button>
						</div>

						<div class="mt-2">
							<label>Bon réception :</label>
							<ap-select2-button name="traceability.receipt" table="receipts" hidden-btn-add="true"
								hidden-btn-edit="true">
							</ap-select2-button>
						</div>

					</div>
				</div>

				<div class="card border-radius flex-grow-1 d-none" id="container-customer">
					<div class="card-body"> 

						<div>
							<label>Commande client :</label>
							<ap-select2-button name="traceability.command_customer" table="commands-customer"
								hidden-btn-add="true" hidden-btn-edit="true">
							</ap-select2-button>
						</div>

						<div class="mt-2">
							<label>Client :</label>
							<ap-select2-button name="traceability.customer" table="customers">
							</ap-select2-button>
						</div>

						<div class="mt-2">
							<label>Site :</label>
							<ap-select2-button name="traceability.site" table="sites">
							</ap-select2-button>
						</div>

					</div>
				</div>

				<div class="card border-radius flex-grow-1 d-none" id="container-stock">
					<div class="card-body"> 

						<div>
							<label>Stock :</label>
							<ap-select2-button name="traceability.stock" table="stock">
							</ap-select2-button>
						</div>

					</div>
				</div>
			</div>
        `;
	}

	public init(parent: HTMLElement = this, N_stock: HTMLSelectElement) {
		const N_T_site = this.querySelector('[name="traceability.site"]') as CE_Select2;
		const N_T_customer = this.querySelector('[name="traceability.customer"]') as CE_Select2;
		const N_T_provider = this.querySelector('[name="traceability.provider"]') as CE_Select2;
		const N_T_stock = this.querySelector('[name="traceability.stock"]') as CE_Select2;
		const N_T_C_command = this.querySelector('[name="traceability.command_customer"]') as CE_Select2;
		const N_T_P_command = this.querySelector('[name="traceability.command_provider"]') as CE_Select2;
		const N_T_Receipt = this.querySelector('[name="traceability.receipt"]') as CE_Select2;

		N_T_customer.create(parent);

		N_T_provider.create(parent);

		N_T_site.setRef({ customer: N_T_customer.selectElement! });
		N_T_site.create(parent);

		N_T_stock.setRef({ currentStock: N_stock });
		N_T_stock.create(parent);

		N_T_C_command.create(parent);

		N_T_P_command.create(parent);

		N_T_Receipt.create(parent, { disabled: true });

		this.selectPostinit['traceability.site'] = N_T_site;
		this.selectPostinit['traceability.customer'] = N_T_customer;
		this.selectPostinit['traceability.provider'] = N_T_provider;
		this.selectPostinit['traceability.command_customer'] = N_T_C_command;
		this.selectPostinit['traceability.command_provider'] = N_T_P_command;
		this.selectPostinit['traceability.stock'] = N_T_stock;
		this.selectPostinit['traceability.receipt'] = N_T_Receipt;

		this.form = new Form(this.querySelector('#form') as HTMLFormElement);

		this.updateRender();
	}

	public postInit() {
		const N_TypeStock = this.querySelector('#stock[name="type"]') as HTMLInputElement;
		const N_TypeProvider = this.querySelector('#provider[name="type"]') as HTMLInputElement;
		const N_TypeCustomer = this.querySelector('#customer[name="type"]') as HTMLInputElement;

		N_TypeStock.addEventListener('change', () => {
			this.updateRender();
		});

		N_TypeProvider.addEventListener('change', () => {
			this.updateRender();
		});

		N_TypeCustomer.addEventListener('change', () => {
			this.updateRender();
		});

		this.selectPostinit['traceability.command_customer'].on('change', async (value) => {
			if (value) {
				this.selectPostinit['traceability.customer'].disable();

				const data = await S_C_Order.getInstance().getById(value as string);

				const customer = await S_Customer.getInstance().getDataToSelect2ByID(data.infos.customer);

				this.form?.setDataByName('traceability.customer', customer);
			} else {
				this.selectPostinit['traceability.customer'].enable();
			}
		});

		this.selectPostinit['traceability.command_provider'].on('change', async (value) => {
			if (value) {
				const data = await S_P_Order.getInstance().getById(value as string);

				if (data) {
					const provider = await S_Provider.getInstance().getDataToSelect2ByID(data.infos.provider);
					this.form?.setDataByName('traceability.provider', provider);
					this.selectPostinit['traceability.provider'].disable();

					const receiptData = await S_Receipt.getInstance().getByOrder(data._id);

					if (receiptData.length) {
						const receipt = await S_Receipt.getInstance().getDataToSelect2ByID(receiptData[0]._id);
						this.form?.setDataByName('traceability.receipt', receipt);
					} else {
						this.form?.setDataByName('traceability.receipt', { id: 'new', text: 'Nouveau BR' });
					}
				} else {
					this.selectPostinit['traceability.provider'].enable();
					this.form?.setDataByName('traceability.receipt', { id: 'new', text: 'Nouveau BR' });
				}
			} else {
				this.selectPostinit['traceability.provider'].enable();
				this.form?.setDataByName('traceability.receipt', { id: '', text: '' });
			}
		});

		this.selectPostinit['traceability.site'].postInit();
		this.selectPostinit['traceability.customer'].postInit();
		this.selectPostinit['traceability.provider'].postInit();
		this.selectPostinit['traceability.command_customer'].postInit();
		this.selectPostinit['traceability.command_provider'].postInit();
		this.selectPostinit['traceability.stock'].postInit();
	}

	private updateRender() {
		const N_provider = this.querySelector('#container-provider') as HTMLElement;
		const N_customer = this.querySelector('#container-customer') as HTMLElement;
		const N_stock = this.querySelector('#container-stock') as HTMLElement;

		N_provider.classList.add('d-none');
		N_customer.classList.add('d-none');
		N_stock.classList.add('d-none');
		const type = this.form?.getDataByName('type');

		if (type === 'provider') {
			N_provider.classList.remove('d-none');
		} else {
			this.form?.setDataByName('traceability.command_provider', { id: '', text: '' });
			this.form?.setDataByName('traceability.provider', { id: '', text: '' });
			this.form?.setDataByName('traceability.receipt', { id: '', text: '' });
		}

		if (type === 'customer') {
			N_customer.classList.remove('d-none');
		} else {
			this.form?.setDataByName('traceability.command_customer', { id: '', text: '' });
			this.form?.setDataByName('traceability.customer', { id: '', text: '' });
			this.form?.setDataByName('traceability.site', { id: '', text: '' });
		}

		if (type === 'stock') {
			N_stock.classList.remove('d-none');
		} else {
			this.form?.setDataByName('traceability.stock', { id: '', text: '' });
		}
	}

	public static register() {
		customElements.define(InputTracaForm.tagName, InputTracaForm);
	}
}

export default InputTracaForm;
